import { render } from "./SessionTree.vue?vue&type=template&id=45180bcc&scoped=true"
import script from "./SessionTree.vue?vue&type=script&lang=js"
export * from "./SessionTree.vue?vue&type=script&lang=js"

import "./SessionTree.vue?vue&type=style&index=0&id=45180bcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45180bcc"]])

export default __exports__